module.exports = __webpack_public_path__ + "assets/img/logo.f570957d.png";